import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import axios from 'axios'
import { connect } from 'react-redux'
import HeaderLeaderBoard from '../advertisements/HeaderLeaderBoard';
import Avatar from './Avatar';
import authservice from '../Authentication/service/authservice';
import styles from './header.module.css'
import adService from '../advertisements/service/adService';
import { ButtonStyle } from '../UIElements/Buttons/ButtonStyle';
import { LinkButton } from '../UIElements/Link_Button/LinkButton';
import listingService from '../listings/service/listingService';
import { notifyUser, type, container } from '../utility/notifyUser';
import aajubaajutmlogo from '../../assets/aajubaajutmlogo.svg'
import moblogo from '../../assets/moblogo.svg'
import CryptoJS from "crypto-js";
import moment from "moment"


class Header extends Component {

    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.state = {
            totalPosts: 0,
            visitorsToday: 0,
            //showEarnings: false,
            selfEarning: 0,
            adViewEarning: 0,
            adDisplayEarning: 0,
            referralEarning: 0,
            estimatedEarning: 0,
            martTotalEarnings: 0,
            commisionEarning: 0,
            referralKey: '',
            // position: this.calculateInitialPosition(),
            type: '',
            message: '',
            data: [],
            userLoggedIn: true,
            ismobile: window.innerWidth <= 991,
            showPopup: false
        }
        this.cookieValue = '';
        this._isMounted = false;
    }
    handleResize = () => {
        this.setState({ ismobile: window.innerWidth <= 768 });
    };

    getStripData = () => {
        axios.get(process.env.REACT_APP_BACKEND_URL + "/abmgr/auth/get-top-strip-data/" + this.cookieValue)
            .then(response => {
                this._isMounted && this.setState({ ...response.data })
            }).catch(e => {
                console.log(e);
            });
    }

    checkLoginSession = () => {
        const user = authservice.getCurrentUser();
        if (user && new Date(user.loginDate).getDate() !== new Date().getDate())
            this.logout();
        const date = new Date();
        if (moment(date).subtract(5, "m") === moment()) {
            notifyUser('INFO', 'You will be logged out automatically at 12 midnight. Please login again to continue working. If you are in middle of posting a listing click on "Submit for Approval" for free listing or "Save as Draft" for paid listing. You can go to "Manage Post" and continue working on the listing after 12 midnight.', type.INFO, container.CENTER);
        } else
            return '';
    }

    async validateGuestUser() {
        let cookieValue = authservice.getCookie('hp.rocks.soon')
        cookieValue = authservice.setCookie('hp.rocks.soon', this.getDeviceFingerprint());

        // if (!cookieValue) {
        //     const response = await axios.get(process.env.REACT_APP_BACKEND_URL + "/abmgr/auth/check-ip");
        //     cookieValue = response.data
        //     if (!cookieValue)
        //         cookieValue = authservice.setCookie('hp.rocks.soon', this.getDeviceFingerprint());
        //     else
        //         authservice.setCookie('hp.rocks.soon', cookieValue);
        // }
        this.saveVisitorTimeout = setTimeout(() => {
            const visitor = {
                deviceId: cookieValue,
                userId: authservice.getCurrentUserid(),
                latLon: this.props.current_coords.latitude + ',' + this.props.current_coords.longitude,
            }
            axios.post(process.env.REACT_APP_BACKEND_URL + "/abmgr/auth/visitor", visitor).catch(err => {
                if (err.response && err.response.status === 400) {
                    alert("Please allow cookies")
                    window.location.reload();
                }
            })
            clearTimeout(this.saveVisitorTimeout)
        }, 10000)
        const superInfo = authservice.getAccountType() === 'SUPER_ADMIN'
        const info = authservice.getAccountType() === 'ADMIN'
        if (info === false && superInfo === false) {
            this.getStripData();
            this.checkLoginSession();
            this.interval = setInterval(() => {
                this.getStripData();
                this.checkLoginSession();
            }, 300000);
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.validateGuestUser()
        window.addEventListener('resize', this.handleResize);
        document.addEventListener("click", this.handleClickOutside, true);
        document.addEventListener("mousedown", this.handleClickOutside);
        window.addEventListener("scroll", this.handleScroll, true);
        // this.scrollText()
        // this.scrollMessage()
    }

    // calculateInitialPosition = () => {
    //     return window.innerWidth;
    // };

    // scrollText = () => {
    //     this.interval = setInterval(() => {
    //         const { position } = this.state;
    //         if (position <= -100) {
    //             this.setState({ position: window.innerWidth });
    //         } else {
    //             this.setState({ position: position - 1 });
    //         }
    //     }, 15);
    // };

    // scrollMessage = () => {
    //     axios.get(process.env.REACT_APP_BACKEND_URL + `/abmgr/notifications/get-notice-message?${this.props.is_login ? 'userId=' + authservice.getCurrentUserid() : 'guestId=' + authservice.getCookie('hp.rocks.soon')}`)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 this.setState({ data: response.data });
    //                 console.log(response.data)
    //             }
    //         })
    //         .catch((error) => {
    //             if (error.response && error.response.data) {
    //                 notifyUser("Fetch Data", "Error fetching data", type.DANGER);
    //             }
    //         });
    // }

    openModal = () => {
        this.setState({ open: true });
    }
    closeModal = () => {
        this.setState({ open: false });
    }

    getDeviceFingerprint = () => {
        const nav = window.navigator;

        const components = [
            nav.hardwareConcurrency || "NA",   // CPU cores
            nav.deviceMemory || "NA",          // RAM (if exposed)
            Intl.DateTimeFormat().resolvedOptions().timeZone, // Timezone
            window.screen.width + "x" + window.screen.height, // Screen resolution
            this.getWebGLRenderer(),                 // GPU info
        ];
        console.log(components)
        const raw = components.join("|");
        console.log(raw)
        return CryptoJS.SHA256(raw).toString();
    }

    getWebGLRenderer = () => {
        try {
            const canvas = document.createElement("canvas");
            const gl = canvas.getContext("webgl");
            const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
            return gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        } catch (e) {
            return "NA";
        }
    }

    // generateGuestId = () => {
    //     var dt = new Date().getTime();
    //     var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //         var r = (dt + Math.random() * 16) % 16 | 0;
    //         dt = Math.floor(dt / 16);
    //         return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    //     });
    //     return uuid;
    // }

    componentDidUpdate(prevProps) {
        if (prevProps.is_login !== this.props.is_login) {
        } else if (!prevProps.is_login && !this.props.is_login) {
            if (this.earningDataUpdate)
                clearInterval(this.earningDataUpdate)
        }
    }

    getEarningData = () => {
        if (authservice.getCurrentUserid() !== null)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/report/getTotalEarning/${authservice.getCurrentUserid()}`, { withCredentials: true })
                .then(response => {
                    if (response.data === 401) {
                        this.logout();
                    }
                    else {
                        const e = response.data;
                        this._isMounted && this.setState({
                            selfEarning: e.selfTotal,
                            adViewEarning: e.adviewEarning,
                            adDisplayEarning: e.adDisplayEarning,
                            estimatedEarning: e.estimatedEarning,
                            commisionEarning: e.commisson,
                            referralEarning: e.downLineEarning,
                            martTotalEarnings: e.martEarnings
                        })
                    }
                }).catch(e => {
                    console.log(e);
                });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this._isMounted = false;
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener("click", this.handleClickOutside, true);
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("scroll", this.handleScroll, true);
    }

    handleClickOutside = (event) => {
        if (this.state.showPopup && this.popupRef && !this.popupRef.contains(event.target)) {
            this.setState({ showPopup: false });
        }
    };

    handleScroll = () => {
        if (this.state.showPopup) {
            this.setState({ showPopup: false });
        }
    };


    logout = () => {
        axios.post(process.env.REACT_APP_BACKEND_URL + "/abmgr/auth/logout?userId=" + authservice.getCurrentUserid())
            .then(resp => {
                this.props.history.push('/login/user')
            }).catch(err => {
                console.log(err)
            })
        authservice.logOut();
        adService.getGuestViewedAds(authservice.getCookie('hp.rocks.soon')).then(data => {
            this.props.sendViewedAds([...data])
        })
        listingService.getViewedListingIds().then(data => {
            this.props.setViewedListings(data)
        })
    }

    handleAddPost = (e) => {
        e.preventDefault();
        this.props.clearPropsData();
        this.props.history.push('/addpost')
    }

    handleAdvertise = (e) => {
        e.preventDefault();
        this.props.clearPropsData();
        this.props.history.push('/advertise')
    }

    // toggleEarnings = () => {
    //     this.setState({ showEarnings: !this.state.showEarnings });
    // };

    render() {
        const location = encodeURI(window.location.origin + '/registration?ref=' + this.props.referralKey)
        const { position } = this.state;
        const { ismobile } = this.state;
        return (
            (this.props.content_page === 'ClipsPage') ? null : <>
                <div className={`d-custom-none ${styles.navbar_sticky}`} id="user_header" style={{ backgroundColor: '#fff' }}>
                    <div className={`container-fluid ${styles.top_strip}`}>
                        <div className={`row align-items-center p-1`}>
                            {this.props.isTablet ?
                                <div className="col-md-3 col-12 text-md-left text-center">
                                    <span className={styles.visitor_count}>Visitors Today: <b>{this.state.visitorsToday + " "}</b>
                                        | Total Posts: <b>{(window.location.href.indexOf("/search") !== -1) ? this.props.listingCount : this.state.totalPosts}</b>
                                    </span>
                                </div> :
                                <div className="row col-12 align-items-center">
                                    <div className="col-md-4 col-12 text-md-left text-right">
                                        <span className={`pl-4 ${styles.contact_link}`}><Link to="/contact" className="social-icon text-xs-center">Contact Support Form</Link>{this.props.content_page === 'HomePage' ? null
                                            : <Link to="/" className="social-icon text-xs-center"> | Back to Home</Link>}</span>
                                    </div>
                                    <div className="col-md-5 col-12 text-md-center text-center">
                                        <div className={styles.earningsContainer}>
                                            {/* {this.props.is_login ?
                                                <b>
                                                    Content: Rs.{this.state.selfEarning}/- &nbsp; Ad View: Rs.{this.state.adViewEarning}/- &nbsp; Ad Sales: Rs.{this.state.adDisplayEarning}/- &nbsp; {this.props.content_page === 'MartPage' ? `Mart: Rs.${this.state.martTotalEarnings}/-` : null}&nbsp;
                                                    {authservice.getAccountType() === "REGISTERED" ?
                                                        <span><Link to={{
                                                            pathname: `/order/${authservice.getCurrentUserid()}`,
                                                            state: { payfor: 'membership' }
                                                        }} className={styles.upgrade_link}> UPGRADE</Link></span> : ' '}
                                                    &nbsp;Aggregator: Rs.{this.state.referralEarning}/-
                                                </b> :
                                                <span className={`text-center ${styles.contact_link}`}>Welcome <b>Guest!</b> Earn while you browse. <Link to='/help'
                                                    className={`social-icon text-xs-center ${styles.header_text}`}><b>Click here to know more</b></Link></span>} */}
                                            {this.props.is_login ?
                                                <>
                                                    <span
                                                        onClick={() => {
                                                            this.setState({ showPopup: !this.state.showPopup });
                                                            this.getEarningData();
                                                        }}
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                    >
                                                        Click here to see&nbsp;<i className='fa fa-hand-o-right'></i>&nbsp;<b>My Income</b>
                                                    </span>

                                                    {this.state.showPopup && (
                                                        <div className={styles.incomePopup} ref={el => (this.popupRef = el)}>
                                                            <h3 style={{ marginBottom: "10px" }}>My Incomes</h3>
                                                            {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Content Income:</b> Rs.{this.state.selfEarning}/-</li>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Ad View Income:</b> Rs.{this.state.adViewEarning}/-</li>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Ad Sales Income:</b> Rs.{this.state.adDisplayEarning}/-</li>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Membership Income:</b> Rs.{this.state.commisionEarning}/-</li>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Mart Sales Income:</b> Rs.{this.state.martTotalEarnings}/-</li>
                                                                <li style={{ textAlign: 'left', padding: '2px' }}><b>Aggregator Income:</b> Rs.{this.state.referralEarning}/-</li>

                                                            </ul> */}
                                                            <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: '400px', fontSize: '14px', background: '#e5f1e4' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Content Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.selfEarning}/-</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Ad View Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.adViewEarning}/-</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Ad Sales Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.adDisplayEarning}/-</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Membership Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.commisionEarning}/-</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Mart Sales Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.martTotalEarnings}/-</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Aggregator Income:</b></td>
                                                                        <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.referralEarning}/-</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    )} </> : null}
                                        </div>
                                    </div>
                                    <div className={`col-md-3 col-12 text-md-right text-right`}>
                                        <span>Visitors Today: <b>{this.state.visitorsToday + " "}</b>
                                            | Total Posts: <b>{(window.location.href.indexOf("/search") !== -1) ? this.props.listingCount : this.state.totalPosts}</b>
                                        </span>
                                    </div>
                                </div>}
                        </div>
                    </div>
                    {this.props.content_page === 'ClipsPage' || window.location.pathname === '/login/user' || window.location.pathname === '/registration' || window.location.pathname === '/activation-success/undefined' ? null :

                        <div className="row col-md-12" style={{ margin: "auto" }}>
                            <div className="col-md-3">
                                <Link to="/">
                                    <img
                                        // className="img-fluid"
                                        src={aajubaajutmlogo}
                                        alt="Logo"
                                        // height="90"
                                        // width='360'
                                        height="100%"
                                        width="100%"

                                    />
                                </Link>
                            </div>
                            {this.props.content_page === 'ListingPage' ? <div className="col-md-7 p-1"></div> : <div className="col-md-7 p-1"><HeaderLeaderBoard /></div>}

                            <div className="col-md-2 d-flex flex-column pl-0 pr-0">
                                <div className="row pt-2 w-100 ml-0 justify-content-center">
                                    {this.props.is_login ? (
                                        <div className={`pr-2 ${styles.avatar}`}>
                                            <Avatar />
                                        </div>
                                    ) : null}
                                    {this.props.is_login ? (
                                        <div className='p-1'>
                                            <LinkButton handleClick={this.logout} text="Logout" />
                                        </div>
                                    ) : location && this.props.location.search !== '' && this.props.content_page !== 'ListingPage' ? null : (
                                        <div className='p-1'>
                                            <Link to="/login/user">
                                                <LinkButton text="Login" />
                                            </Link>
                                        </div>
                                    )}
                                    <div className='p-1'> &nbsp;|&nbsp; </div>
                                    {!this.props.is_login && this.props.content_page !== 'RegistrationPage' && (
                                        <>
                                            <div className='p-1'>
                                                <Link to="/registration">
                                                    <LinkButton text="Register" />
                                                </Link>
                                            </div>
                                            <div className='p-1'>&nbsp;|&nbsp;</div>
                                        </>
                                    )}

                                    <div className='p-1'>
                                        <Link to="/help">
                                            <LinkButton text="Help" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="row w-100 ml-0">
                                    <div className='p-1' style={{ maxWidth: "50%" }}>
                                        <ButtonStyle type="button" className="btn" text="Advertise" handleClick={this.handleAdvertise} />
                                    </div>
                                    <div className='p-1'>
                                        <ButtonStyle type="button" className="btn" text="Add Post" handleClick={this.handleAddPost} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="d-custom-block" id="user_header" style={{ backgroundColor: '#fff' }}>
                    <div className={`container-fluid ${styles.top_strip}`}>
                        {this.props.content_page === 'LoginPage' || this.props.content_page === 'RegistrationPage' ? <span className='text-left'><Link to='/' style={{ position: 'absolute' }}>
                            <i style={{ fontSize: '25px', top: '-2px' }} className="fa fa-home home_link styled-icon"></i>
                        </Link></span> : null}
                        {this.props.content_page === 'ClipsPage' ? null :
                            <div className={`row align-items-center p-1`}>
                                <div className="col-md-12 col-12 text-md-center text-center">
                                    {/* {this.props.is_login ?
                                        <b>
                                            Content: Rs.{this.state.selfEarning}/- &nbsp; Ad View: Rs.{this.state.adViewEarning}/- &nbsp;<br></br>
                                            Ad Sales: Rs.{this.state.adDisplayEarning}/- &nbsp; {this.props.content_page === 'MartPage' ? `Mart: Rs.${this.state.martTotalEarnings}/-` : null}
                                            {authservice.getAccountType() === "REGISTERED" ?
                                                <span><Link to={{
                                                    pathname: `/order/${authservice.getCurrentUserid()}`,
                                                    state: { payfor: 'membership' }
                                                }} className={styles.upgrade_link}> UPGRADE</Link></span> : ' '}
                                            &nbsp; Aggregator: Rs.{this.state.referralEarning}/- <br></br>
                                        </b> : null} */}
                                    {this.props.is_login ?
                                        <>
                                            <span
                                                onClick={() => {
                                                    this.setState({ showPopup: !this.state.showPopup });
                                                    this.getEarningData();
                                                }}
                                                style={{ cursor: "pointer", textDecoration: "none" }}
                                            >
                                                Click here to see&nbsp;<i className='fa fa-hand-o-right'></i>&nbsp;<b>My Income</b>
                                            </span>

                                            {this.state.showPopup && (
                                                <div className={styles.incomePopupMob} ref={el => (this.popupRef = el)}>
                                                    <h3 style={{ marginBottom: "10px" }}>My Earnings</h3>
                                                    {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Content Income:</b> Rs.{this.state.selfEarning}/-</li>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Ad View Income:</b> Rs.{this.state.adViewEarning}/-</li>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Ad Sales Income:</b> Rs.{this.state.adDisplayEarning}/-</li>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Membership Income:</b> Rs.{this.state.commisionEarning}/-</li>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Mart Sales Income:</b> Rs.{this.state.martTotalEarnings}/-</li>
                                                        <li style={{ textAlign: 'left', padding: '2px' }}><b>Aggregator Income:</b> Rs.{this.state.referralEarning}/-</li>
                                        
                                                    </ul> */}
                                                    <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: '400px', fontSize: '14px', background: '#e5f1e4' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Content Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.selfEarning}/-</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Ad View Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.adViewEarning}/-</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Ad Sales Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.adDisplayEarning}/-</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Membership Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.commisionEarning}/-</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Mart Sales Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.martTotalEarnings}/-</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'left', padding: '4px 8px', border: '1px solid #ddd' }}><b>Aggregator Income:</b></td>
                                                                <td style={{ textAlign: 'center', padding: '4px 8px', border: '1px solid #ddd' }}>Rs.{this.state.referralEarning}/-</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}</> : null}<br></br>


                                    <span className={styles.visitor_count}>Visitors Today: <b>{this.state.visitorsToday + " "}</b>
                                        | Total Posts: <b>{(window.location.href.indexOf("/search") !== -1) ? this.props.listingCount : this.state.totalPosts}</b>
                                    </span>
                                </div>

                            </div>}
                    </div>
                    {this.props.content_page === 'ClipsPage' || this.props.content_page === 'LoginPage' || this.props.content_page === 'RegistrationPage' ? null :
                        <div className="row col-12 col-md-12">
                            <div className="col-3 col-md-3 float-left">
                                <Link to="/">
                                    <img
                                        src={ismobile ? moblogo : aajubaajutmlogo}
                                        alt="Logo"
                                        style={ismobile ? {} : { width: "45vw", maxWidth: "300px", maxHeight: "100px" }}
                                    />
                                </Link>
                            </div>
                            <div className="col-9 col-md-9 d-flex flex-column align-items-end">
                                <div className="row pt-2 w-100 justify-content-end pr-3">
                                    {this.props.is_login ? (
                                        <div className={`pr-2 ${styles.avatar}`}>
                                            <Avatar />
                                        </div>
                                    ) : null}
                                    {this.props.is_login ? (
                                        <div className='p-1'>
                                            <LinkButton handleClick={this.logout} text="Logout" />
                                        </div>
                                    ) : location && this.props.location.search !== '' && this.props.content_page !== 'ListingPage' ? null : (
                                        <div className='p-1'>
                                            <Link to="/login/user">
                                                <LinkButton text="Login" />
                                            </Link>
                                        </div>
                                    )}
                                    <div className='p-1'> &nbsp;|&nbsp; </div>
                                    {!this.props.is_login && this.props.content_page !== 'RegistrationPage' && (
                                        <>
                                            <div className='p-1'>
                                                <Link to="/registration">
                                                    <LinkButton text="Register" />
                                                </Link>
                                            </div>
                                            <div className='p-1'>&nbsp;|&nbsp;</div>
                                        </>
                                    )}
                                    <div className='p-1'>
                                        <Link to="/help">
                                            <LinkButton text="Help" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="row w-100 justify-content-end">
                                    <div className='p-1'>
                                        <ButtonStyle type="button" className="btn" text="Advertise" handleClick={this.handleAdvertise} />
                                    </div>
                                    <div className='p-1'>
                                        <ButtonStyle type="button" className="btn" text="Add Post" handleClick={this.handleAddPost} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        listingCount: (state.searching_counts.business + state.searching_counts.event + state.searching_counts.job + state.searching_counts.news + state.searching_counts.article),
        is_login: state.is_login,
        content_page: state.content_page,
        current_coords: state.current_coords,
        isAdmin: state.isAdmin,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        isLogin: (is_login) => dispatch({ type: 'IS_LOGIN', is_login: is_login }),
        clearPropsData: () => dispatch({ type: 'CLEAR_DATA' }),
        sendViewedAds: (viewedAds) => dispatch({ type: 'ALL_VIEWED_ADS', viewedAds: viewedAds }),
        setViewedListings: (listingIds) => dispatch({ type: 'VIEWED_LISTINGS', viewedListings: listingIds }),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));